/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "./src/css/style.css";
import "./src/css/global.css";
import "./src/css/noPurge.css";
import "@fontsource/roboto";


export const onClientEntry = async () => {
    if (typeof IntersectionObserver === `undefined`) {
        await import(`intersection-observer`);
    }
}

// Load the PLUS Medical chatbot widget on every page by appending the
// generated script from the site's `static/` directory. The script lives
// at /plusmedical-chatbot.js and is added idempotently to avoid duplicates.
export const onClientEntryLoadChatbot = () => {
    if (typeof window === 'undefined') return;
    try {
        if (!document.getElementById('plusmedical-chatbot-script')) {
            const script = document.createElement('script');
            script.id = 'plusmedical-chatbot-script';
            script.src = '/plusmedical-chatbot.js';
            script.async = true;
            script.onload = () => {
                // noop or telemetry
                // console.info('PlusMedical chatbot script loaded');
            };
            script.onerror = () => {
                // Fail quietly but log for debugging
                console.warn('Failed to load /plusmedical-chatbot.js');
            };
            // Prefer body if available, otherwise head
            const parent = document.body || document.head || document.documentElement;
            parent.appendChild(script);
        }
    } catch (e) {
        // Avoid breaking site if DOM manipulation fails
        // eslint-disable-next-line no-console
        console.warn('Could not inject PlusMedical chatbot script', e);
    }
};



// Call the loader after client entry so it runs on every page.
if (typeof window !== 'undefined') {
    // Use DOMContentLoaded to ensure body is present when running outside Gatsby lifecycle
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onClientEntryLoadChatbot);
    } else {
        onClientEntryLoadChatbot();
    }
}

// const addScript = url => {
//     const script = document.createElement("script")
//     script.src = url
//     script.async = true
//     document.body.appendChild(script)
//   }

// export const onClientEntry = () => {
//     // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
//     if (!(`IntersectionObserver` in window)) {
//         import(`intersection-observer`)
//     }
// }

// export const onRouteUpdate = () => {
//     navigator.serviceWorker.register('/sw.js').then((reg) => {
//       reg.update();
//     });
//   };

//   export const onServiceWorkerUpdateReady = () => {
//     window.location.reload(true)
//   };
  